import React, { useState } from "react";
import InputBox from "./Components/InputBox";
import Swal from "sweetalert2";
import { db, storage } from "./firebase";
import { Navbar } from "react-bootstrap";

function JobPost() {
  const [company, setCompany] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [exp, setExp] = useState("");
  const [location, setLocation] = useState("");
  const [salary, setSalary] = useState("");
  const [skills, setSkills] = useState([]);
  const [link, setLink] = useState("");
  const [name, setName] = useState("");
  const [batch, setBatch] = useState("");
  const [email, setEmail] = useState("");
  const [companyLogo, setCompanyLogo] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [progress, setProgress] = useState(0);

  const handleChange = (e) => {
    if (e.target.files[0]) {
      setCompanyLogo(e.target.files[0]);
    }
  };

  const handleUpload = () => {
    const uploadTask = storage
      .ref(`companyLogos/${companyLogo.name}`)
      .put(companyLogo);

    uploadTask.on(
      "state_changes",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => {
        console.log(error);
        alert(error.message);
      },
      () => {
        storage
          .ref("companyLogos/")
          .child(companyLogo.name)
          .getDownloadURL()
          .then((url) => {
            db.ref(`jobPosts/`)
              .push({
                company: company,
                companyLogo: url,
                jobTitle: jobTitle,
                exp: exp,
                location: location,
                salary: salary,
                skills: skills,
                link: link.includes("@")?`mailto:${link}`:link,
                endDate: endDate,
                name: name,
                batch: batch,
                email: email,
              })
              .then(() => {
                setProgress(0);
                setCompany("");
                setJobTitle("");
                setExp("");
                setLocation("");
                setSalary("");
                setSkills([]);
                setLink("");
                setEndDate("");
                setName("");
                setBatch("");
                setEmail("");
                Swal.fire({
                  icon: "success",
                  title: "Job Posted",
                });
              })
              .catch((error) => {
                alert(error.message);
              });
          });
      }
    );
  };

  return (
   
    <div className="flex flex-col w-full px-5 md:px-10 mt-20">
        <p className="text-4xl font-bold leading-relaxed text-center mb-6">
        Post a Job
      </p>
      <div className="flex md:flex-row flex-col gap-8 w-full">
        <div className="form w-full">
      <p className="text-3xl font-semibold leading-relaxed"> 
        Job/Internship Details
      </p> 
          <form
            className="jobpostform mb-20"
            onSubmit={(e) => {
              e.preventDefault();
              handleUpload();
            }}
          >
            <InputBox
              type="textarea"
              name="jobDes"
              placeholder="Job/Internship Title" 
              value={jobTitle}
              required
              onChange={setJobTitle}
            ></InputBox>
            <InputBox
              type="text"
              name="company"
              placeholder="Company Name"
              value={company}
              required
              onChange={setCompany}
            />
            <div className="my-4">
              <label className="block uppercase  tracking-wide text-charcoal-darker text-xs font-bold">
                Company Logo
              </label>
              <input
                className="w-full rounded-md shadow-lg p-4 border-0 focus:outline-none"
                type="file"
                name="companyLogo"
                required
                placeholder="Company Logo"
                onChange={handleChange}
                accept="image/*"
              />
            </div>


            <label className="block uppercase tracking-wide text-charcoal-darker text-xs font-bold">
              Experience required
            </label>
            <select
required
        value={exp}
        onChange={({ target: { value } }) => setExp(value)}
      >
        {[["Internship","Internship"],["0-1yrs","0-1yrs"],["1-3yrs","1-3yrs"],["3-6yrs","3-6yrs"],["6+yrs","6+yrs"]].map(([value, text]) => (
          <option value={value}>
            {text}
          </option>
        ))}
      </select> 
      

            <InputBox
              type="text"
              name="loc"
              placeholder="Location(Optional)"
              value={location}
              onChange={setLocation}
            ></InputBox>
            <InputBox
              type="text"
              name="salary"
              placeholder="Stipend/Salary(Optional)"
              value={salary}
              onChange={setSalary}
            ></InputBox>

            <InputBox
              type="text"
              name="skills"
              placeholder=" Preffered Skills"
              value={skills}
              onChange={setSkills}
            ></InputBox>

            <InputBox
              type="date"
              name="endDate"
              placeholder="Apply By"
              value={endDate}
              onChange={setEndDate}
            ></InputBox>
            <InputBox
              type="text"
              name="link"
              placeholder="Apply Link / Email Id"
              value={link}
              required
              onChange={setLink}
            ></InputBox> 
          </form>
        </div>
        {/* <img
          className="hidden md:block"
          src="Postajob.png"
          alt="Postajob.png"
        /> */}

        <div className="h-96 w-2 bg-blue-900 mt-10 rounded-xl">

        </div>
        <div className="flex flex-col w-full">

        <p className="text-3xl font-semibold leading-relaxed">Your Details</p> 
            <InputBox
              type="text"
              name="name"
              required
              placeholder="Name"
              value={name}
              onChange={setName}
            />
            <InputBox
              type="text"
              name="batch"
              required
              placeholder="Batch"
              value={batch}
              onChange={setBatch}
            />
            <InputBox
              type="text"
              name="email"
              placeholder="Email Id"
              value={email}
              required
              onChange={setEmail}
            />
            <button
              type="submit"
              className=" w-full bg-orange-500 rounded-lg p-2 shadow-xl font-semibold text-lg text-white"
            >
              Post A Job
            </button>

        </div>
      </div>
    </div>
   
  );
}

export default JobPost;
